module.exports = __webpack_public_path__ + "static/img/70003A_3_C_20200611_LC.d80f5d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/70003A_3_C_20200611_LC.png
// module id = VksQ
// module chunks = 0